// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-gray-bg[data-v-185d7aaa]{background-color:#f5f5f5}.green[data-v-185d7aaa]{background-color:#00a351}.red[data-v-185d7aaa]{background-color:#e6464c}.small-container[data-v-185d7aaa]{max-width:92rem}.arrow-right[data-v-185d7aaa]{fill:#333;cursor:pointer;text-align:center;height:1.6rem;width:1.6rem;display:inline}.max-width[data-v-185d7aaa]{max-width:43rem}@media (min-width:768px){.max-w-450[data-v-185d7aaa]{max-width:45rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
